import * as angular from "angular";
import {IController} from "angular";

export class AccountVehicleMakeCtrl implements IController {

  target: any;

  private loading: boolean;
  private vehicleMakes: any;

  /* @ngInject */
  constructor(private VehiclesConstants) {
  }

  $onInit() {
    this.loading = false;
    this.vehicleMakes = this.VehiclesConstants.makes;
  }

}

angular
  .module('bringoz.admin.accounts')
  .component('accountVehicleMake', {
    require: {
      form: '^form'
    },
    bindings: {
      target: '<'
    },
    template: require('./account-vehicle-make.html').default,
    controller: AccountVehicleMakeCtrl
  });
